import EnglishCanada from './locale/en-CA';
import FrenchCanada from './locale/fr-CA';
import EnglishCanadaRebranded from './locale/rebranded/en-CA';
import FrenchCanadaRebranded from './locale/rebranded/fr-CA';
import isOmpPlatform from '../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const messages = {
  'en-CA': isOmp ? EnglishCanadaRebranded : EnglishCanada,
  'fr-CA': isOmp ? FrenchCanadaRebranded : FrenchCanada
};

export default messages;
